import c from "clsx";
import * as m from "react";
import e, { forwardRef as l, useState as z, useCallback as de, useRef as I, Children as me, useEffect as F } from "react";
import { useFloating as _e, offset as ue, arrow as pe, size as ve, autoUpdate as ge, useClick as fe, useDismiss as Ce, useRole as Ee, useMergeRefs as be, useInteractions as we, FloatingOverlay as he, FloatingArrow as ye } from "@floating-ui/react";
import * as N from "@radix-ui/react-tabs";
const Ne = "_icon_1i7w6_1", ke = "_xs_1i7w6_12", xe = "_sm_1i7w6_16", Le = "_base_1i7w6_20", qe = "_lg_1i7w6_24", He = "_xl_1i7w6_28", Re = "_x1_1i7w6_32", Ie = "_x2_1i7w6_36", ze = "_x3_1i7w6_40", We = "_x4_1i7w6_44", $ = {
  icon: Ne,
  xs: ke,
  sm: xe,
  base: Le,
  lg: qe,
  xl: He,
  x1: Re,
  x2: Ie,
  x3: ze,
  x4: We
}, w = l(
  ({ icon: a, label: t, size: n = "base", className: s, ...r }, o) => {
    const i = a;
    return /* @__PURE__ */ e.createElement(
      i,
      {
        "aria-hidden": t ? void 0 : !0,
        "aria-label": t,
        className: c($.icon, $[n], s),
        ref: o,
        role: t ? "img" : void 0,
        ...r
      }
    );
  }
);
w.displayName = "Icon";
const je = l(function(t, n) {
  return /* @__PURE__ */ m.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ m.createElement(
      "path",
      {
        d: "M16 11L12 15L8 11",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      }
    )
  );
}), Me = "_summary_1ce70_1", Te = "_title_1ce70_16", De = "_titleWrapper_1ce70_21", $e = "_isNested_1ce70_33", Ae = "_isExpanded_1ce70_42", Be = "_chevronIcon_1ce70_47", Ge = "_chevronIconExpanded_1ce70_58", Oe = "_dark_1ce70_62", Se = "_light_1ce70_79", y = {
  summary: Me,
  title: Te,
  titleWrapper: De,
  isNested: $e,
  isExpanded: Ae,
  chevronIcon: Be,
  chevronIconExpanded: Ge,
  dark: Oe,
  light: Se
}, V = l(
  ({ title: a, isExpanded: t = !0, isNested: n = !1, variant: s = "dark", onClick: r }, o) => /* @__PURE__ */ e.createElement(
    "summary",
    {
      "aria-expanded": t,
      className: c(y.summary),
      onClick: r,
      ref: o
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: c(y.titleWrapper, y[s], {
          [y.isExpanded]: t,
          [y.isNested]: n
        })
      },
      /* @__PURE__ */ e.createElement(
        w,
        {
          className: c(y.chevronIcon, {
            [y.chevronIconExpanded]: t
          }),
          icon: je,
          size: "lg"
        }
      ),
      /* @__PURE__ */ e.createElement("div", { className: y.title }, a)
    )
  )
);
V.displayName = "AccordionHeader";
const Pe = "_card_1q80j_1", Fe = "_padded_1q80j_8", Ve = "_cardHeader_1q80j_12", Ze = "_cardTitle_1q80j_18", Ke = "_cardContent_1q80j_23", Xe = "_cardFooter_1q80j_28", Ue = "_cardGroup_1q80j_32", Je = "_flush_1q80j_40", Qe = "_condensed_1q80j_56", Ye = "_horizontalCardGroupWrapper_1q80j_71", et = "_rightHandle_1q80j_77", tt = "_leftHandle_1q80j_77", nt = "_pagination_1q80j_112", at = "_paginationItem_1q80j_119", st = "_active_1q80j_126", rt = "_horizontalCardGroup_1q80j_71", u = {
  card: Pe,
  padded: Fe,
  cardHeader: Ve,
  cardTitle: Ze,
  cardContent: Ke,
  cardFooter: Xe,
  cardGroup: Ue,
  flush: Je,
  condensed: Qe,
  horizontalCardGroupWrapper: Ye,
  rightHandle: et,
  leftHandle: tt,
  pagination: nt,
  paginationItem: at,
  active: st,
  horizontalCardGroup: rt
}, ot = "div", lt = l(
  ({
    as: a,
    className: t,
    children: n,
    condensed: s = !1,
    flushOnMobile: r = !1,
    padded: o = !1,
    ...i
  }, d) => {
    const p = a ?? ot;
    return /* @__PURE__ */ e.createElement(
      p,
      {
        ...i,
        className: c(
          u.cardGroup,
          {
            [u.flush]: r,
            [u.condensed]: s,
            [u.padded]: o
          },
          t
        ),
        ref: d
      },
      n
    );
  }
);
lt.displayName = "CardGroup";
const it = "_accordion_1ysxk_1", ct = {
  accordion: it
}, Z = l(
  ({
    children: a,
    renderTitle: t,
    isInitiallyExpanded: n = !0,
    isNested: s = !1,
    variant: r = "dark",
    onToggle: o
  }, i) => {
    const [d, p] = z(n), v = de(
      (g) => {
        g.preventDefault(), p(!d), o && o(!d);
      },
      [d, o]
    );
    return /* @__PURE__ */ e.createElement(
      "details",
      {
        className: ct.accordion,
        "data-testid": "sports-expandable-accordion",
        open: d,
        ref: i
      },
      t({ isExpanded: d, isNested: s, variant: r, onClick: v }),
      a
    );
  }
);
Z.displayName = "Accordion";
const A = l(function(t, n) {
  return /* @__PURE__ */ m.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ m.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.245 18.0385H5.75495C4.98009 18.0385 4.49963 17.1953 4.89465 16.5287L11.1397 5.9902C11.527 5.3366 12.4729 5.3366 12.8602 5.9902L19.1053 16.5287C19.5003 17.1953 19.0198 18.0385 18.245 18.0385ZM11.2874 9.28764C11.2671 8.88013 11.592 8.53857 12 8.53857C12.408 8.53857 12.7329 8.88013 12.7125 9.28764L12.525 13.0392C12.511 13.3189 12.2801 13.5386 12 13.5386C11.7199 13.5386 11.489 13.3189 11.475 13.0392L11.2874 9.28764ZM12 16.0386C12.425 16.0386 12.75 15.7136 12.75 15.2885C12.75 14.9761 12.5 14.5386 12 14.5386C11.575 14.5386 11.25 14.8761 11.25 15.2885C11.25 15.7136 11.5875 16.0386 12 16.0386Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
}), B = l(function(t, n) {
  return /* @__PURE__ */ m.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ m.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM13.1666 8.49997C13.1666 9.1443 12.6443 9.66664 12 9.66664C11.3556 9.66664 10.8333 9.1443 10.8333 8.49997C10.8333 7.85564 11.3556 7.3333 12 7.3333C12.6443 7.3333 13.1666 7.85564 13.1666 8.49997ZM12 11C12.5523 11 13 11.4477 13 12V15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0523 11 15.5V12C11 11.4477 11.4477 11 12 11Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
}), dt = l(function(t, n) {
  return /* @__PURE__ */ m.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ m.createElement(
      "path",
      {
        d: "M8 8L16 16M16 8L8 16",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2
      }
    )
  );
}), mt = "_alert_qs948_1", _t = "_square_qs948_9", ut = "_aggressive_qs948_62", f = {
  alert: mt,
  square: _t,
  "passive-success": "_passive-success_qs948_13",
  "passive-information": "_passive-information_qs948_18",
  "passive-warning": "_passive-warning_qs948_23",
  "passive-destructive": "_passive-destructive_qs948_28",
  "passive-brand-update": "_passive-brand-update_qs948_33",
  "passive-aggressive": "_passive-aggressive_qs948_38",
  "passive-aggressive-success": "_passive-aggressive-success_qs948_42",
  "passive-aggressive-information": "_passive-aggressive-information_qs948_46",
  "passive-aggressive-warning": "_passive-aggressive-warning_qs948_50",
  "passive-aggressive-destructive": "_passive-aggressive-destructive_qs948_54",
  "passive-aggressive-brand-update": "_passive-aggressive-brand-update_qs948_58",
  aggressive: ut,
  "alert-description": "_alert-description_qs948_65",
  "alert-dismiss-icon": "_alert-dismiss-icon_qs948_68",
  "aggressive-success": "_aggressive-success_qs948_72",
  "aggressive-information": "_aggressive-information_qs948_76",
  "aggressive-warning": "_aggressive-warning_qs948_80",
  "aggressive-destructive": "_aggressive-destructive_qs948_84",
  "aggressive-brand-update": "_aggressive-brand-update_qs948_88",
  "alert-title": "_alert-title_qs948_92",
  "alert-icon": "_alert-icon_qs948_103",
  "alert-dismiss-button": "_alert-dismiss-button_qs948_115"
}, pt = "div", vt = [
  "warning",
  "destructive",
  "brand-update"
], gt = (a) => vt.includes(a), ft = l(
  ({
    as: a,
    title: t,
    variant: n = "passive",
    level: s,
    isSquare: r,
    onDismiss: o,
    dismissLabel: i,
    className: d,
    isCollapsible: p,
    children: v,
    ...g
  }, E) => {
    const h = a ?? pt, C = gt(s);
    return /* @__PURE__ */ e.createElement(
      h,
      {
        "aria-label": t,
        "aria-live": C ? "assertive" : "polite",
        className: c(
          f.alert,
          r ? f.square : void 0,
          f[n],
          f[`${n}-${s}`],
          n === "passive-aggressive" ? f[`passive-${s}`] : void 0,
          d
        ),
        ref: E,
        role: "alert",
        ...g
      },
      p ? /* @__PURE__ */ e.createElement(
        Z,
        {
          renderTitle: (_) => /* @__PURE__ */ e.createElement(
            V,
            {
              ..._,
              title: /* @__PURE__ */ e.createElement("div", { className: f["alert-title"] }, /* @__PURE__ */ e.createElement(
                w,
                {
                  className: f["alert-icon"],
                  icon: C ? A : B,
                  size: "lg"
                }
              ), t ? /* @__PURE__ */ e.createElement("h2", null, t) : null)
            }
          ),
          variant: "transparent"
        },
        /* @__PURE__ */ e.createElement("div", { className: f["alert-description"] }, v)
      ) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: f["alert-title"] }, /* @__PURE__ */ e.createElement(
        w,
        {
          className: f["alert-icon"],
          icon: C ? A : B,
          size: "lg"
        }
      ), t ? /* @__PURE__ */ e.createElement("h2", null, t) : v, o ? /* @__PURE__ */ e.createElement(
        "button",
        {
          "aria-label": i,
          className: f["alert-dismiss-button"],
          onClick: o,
          type: "button"
        },
        /* @__PURE__ */ e.createElement(
          w,
          {
            className: f["alert-dismiss-icon"],
            icon: dt,
            size: "lg"
          }
        )
      ) : null), t ? /* @__PURE__ */ e.createElement("span", { className: f["alert-description"] }, v) : null)
    );
  }
);
ft.displayName = "Alert";
const Ct = "_button_dblcz_1", Et = "_small_dblcz_19", bt = "_inline_dblcz_25", wt = "_fullWidth_dblcz_29", ht = "_primary_dblcz_34", yt = "_secondary_dblcz_64", Nt = "_tertiary_dblcz_91", kt = "_iconRight_dblcz_146", k = {
  button: Ct,
  small: Et,
  inline: bt,
  fullWidth: wt,
  primary: ht,
  secondary: yt,
  tertiary: Nt,
  "brand-promotion": "_brand-promotion_dblcz_121",
  iconRight: kt
}, xt = "button", Lt = l(
  ({
    as: a,
    className: t,
    children: n,
    variant: s = "primary",
    size: r = "normal",
    fullWidth: o,
    icon: i,
    iconPosition: d = "left",
    ...p
  }, v) => {
    const g = a ?? xt;
    return /* @__PURE__ */ e.createElement(
      g,
      {
        type: g === "button" ? "button" : void 0,
        ...p,
        className: c(
          k.button,
          k[s],
          {
            [k.small]: r === "small",
            [k.iconRight]: i && d === "right",
            [k.inline]: !o,
            [k.fullWidth]: o
          },
          t
        ),
        ref: v
      },
      i ? /* @__PURE__ */ e.createElement(w, { icon: i }) : null,
      n
    );
  }
);
Lt.displayName = "Button";
const j = {
  XXS: 4,
  XS: 8,
  SM: 12,
  MD: 16,
  LG: 24,
  XL: 32,
  XXL: 40
}, qt = "_dropdown_10wdf_1", Ht = "_overlay_10wdf_13", Rt = "_title_10wdf_17", It = "_body_10wdf_30", zt = "_padded_10wdf_36", L = {
  dropdown: qt,
  overlay: Ht,
  title: Rt,
  body: It,
  padded: zt
}, G = 14, O = 1, Wt = l(
  ({
    children: a,
    triggerEl: t,
    title: n,
    padded: s = !1,
    verticalOffset: r = "XS",
    dropdownRole: o = "dialog",
    overlay: i = !1,
    overlayProps: d = {},
    isDefaultOpen: p = !1,
    isOpenCallback: v,
    ...g
  }, E) => {
    const [h, C] = z(p), _ = I(null), W = I(), X = (b) => {
      C(b), v?.(b);
    }, { refs: T, strategy: U, x: J, y: Q, context: H } = _e({
      open: h,
      onOpenChange: X,
      placement: "bottom-start",
      strategy: "absolute",
      middleware: [
        ue({
          mainAxis: j[r]
        }),
        pe({
          element: _
        }),
        ve({
          padding: j.MD,
          apply({ availableWidth: b, elements: R, middlewareData: D }) {
            if (Object.assign(R.floating.style, {
              width: `${b}px`,
              maxHeight: `${window.innerHeight - R.reference.getBoundingClientRect().bottom - (D.offset?.y ?? 0) - j.MD}px`
            }), D.arrow && _.current && W.current) {
              const { left: oe } = R.reference.getBoundingClientRect(), { left: le, width: ie } = W.current.getBoundingClientRect(), ce = le - oe - (G / 2 + O) + ie / 2;
              Object.assign(_.current.style, {
                left: `${Math.trunc(ce)}px`
              });
            }
          }
        })
      ],
      whileElementsMounted(...b) {
        return ge(...b, { ancestorScroll: !1 });
      }
    }), Y = fe(H), ee = Ce(H, {
      outsidePressEvent: "mousedown"
    }), te = Ee(H, { role: o }), ne = be([T.setFloating, ...E ? [E] : []]), { getFloatingProps: ae, getReferenceProps: se } = we([
      Y,
      ee,
      te
    ]), re = (b) => {
      b.key === "Enter" && C(!1);
    };
    return /* @__PURE__ */ e.createElement(e.Fragment, null, t({ refs: T, getReferenceProps: se, arrowRef: W, isOpen: h }), i && h ? /* @__PURE__ */ e.createElement(
      he,
      {
        ...d,
        className: c(L.overlay, d.className)
      }
    ) : null, h ? /* @__PURE__ */ e.createElement(
      "div",
      {
        ...g,
        className: L.dropdown,
        ref: ne,
        style: {
          position: U,
          top: Q,
          left: J
        },
        ...ae()
      },
      n ? /* @__PURE__ */ e.createElement(
        "span",
        {
          className: c(L.title),
          onKeyDown: (b) => {
            re(b);
          },
          role: "button",
          tabIndex: 0
        },
        n
      ) : null,
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: c(L.body, { [L.padded]: s })
        },
        a
      ),
      /* @__PURE__ */ e.createElement(
        ye,
        {
          context: H,
          fill: "#ECECEC",
          ref: _,
          stroke: "#999",
          strokeWidth: O,
          width: G
        }
      )
    ) : null);
  }
);
Wt.displayName = "Dropdown";
const jt = l(function(t, n) {
  return /* @__PURE__ */ m.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ m.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M6.75 8C6.75 7.30964 7.30964 6.75 8 6.75H10.5C10.9142 6.75 11.25 6.41421 11.25 6C11.25 5.58579 10.9142 5.25 10.5 5.25H8C6.48122 5.25 5.25 6.48122 5.25 8V16.871C5.25 18.3898 6.48122 19.621 8 19.621H16.871C18.3898 19.621 19.621 18.3898 19.621 16.871V14C19.621 13.5858 19.2852 13.25 18.871 13.25C18.4568 13.25 18.121 13.5858 18.121 14V16.871C18.121 17.5613 17.5613 18.121 16.871 18.121H8C7.30964 18.121 6.75 17.5613 6.75 16.871V8ZM14.129 5.25C13.7148 5.25 13.379 5.58579 13.379 6C13.379 6.41421 13.7148 6.75 14.129 6.75H16.9611L8.87675 14.2569C8.57322 14.5387 8.55565 15.0133 8.8375 15.3168C9.11935 15.6203 9.5939 15.6379 9.89743 15.356L18.121 7.71991V10.5367C18.121 10.9509 18.4568 11.2867 18.871 11.2867C19.2852 11.2867 19.621 10.9509 19.621 10.5367V6C19.621 5.58579 19.2852 5.25 18.871 5.25H14.129Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
}), Mt = "_link_56gj4_1", Tt = "_embedded_56gj4_23", Dt = "_standalone_56gj4_32", M = {
  link: Mt,
  embedded: Tt,
  standalone: Dt
}, $t = "a", At = l(
  ({
    as: a,
    className: t,
    children: n,
    standalone: s,
    isExternal: r,
    ...o
  }, i) => {
    const d = a ?? $t, { startIcon: p, endIcon: v, ...g } = {
      startIcon: void 0,
      endIcon: void 0,
      ...o
    }, E = r ? jt : v;
    return /* @__PURE__ */ e.createElement(
      d,
      {
        target: r ? "_blank" : void 0,
        ...g,
        className: c(
          M.link,
          {
            [M.embedded]: !s,
            [M.standalone]: s
          },
          t
        ),
        ref: i
      },
      typeof p < "u" ? /* @__PURE__ */ e.createElement(w, { icon: p }) : null,
      typeof p < "u" || typeof E < "u" ? /* @__PURE__ */ e.createElement("span", null, n) : n,
      E ? /* @__PURE__ */ e.createElement(w, { icon: E }) : null
    );
  }
);
At.displayName = "Link";
const Bt = l(function(t, n) {
  return /* @__PURE__ */ m.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ m.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M20.0412 17.6H8.21629L4.15849 12L8.21629 6.4H20.0412V17.6ZM20.7703 5H7.83567C7.59723 5 7.37338 5.112 7.23702 5.3003L2.67172 11.6003C2.49745 11.8404 2.49745 12.1596 2.67172 12.3997L7.23702 18.6997C7.37338 18.888 7.59723 19 7.83567 19H20.7703C21.1728 19 21.4995 18.6864 21.4995 18.3V5.7C21.4995 5.3136 21.1728 5 20.7703 5ZM10.4111 14.7699C10.5533 14.9064 10.7399 14.975 10.9266 14.975C11.1133 14.975 11.2999 14.9064 11.4421 14.7699L13.2964 12.9898L15.1507 14.7699C15.2928 14.9064 15.4795 14.975 15.6662 14.975C15.8528 14.975 16.0395 14.9064 16.1817 14.7699C16.4668 14.4962 16.4668 14.0538 16.1817 13.7801L14.3274 12L16.1817 10.2199C16.4668 9.9462 16.4668 9.5038 16.1817 9.2301C15.8966 8.9564 15.4358 8.9564 15.1507 9.2301L13.2964 11.0102L11.4421 9.2301C11.157 8.9564 10.6962 8.9564 10.4111 9.2301C10.126 9.5038 10.126 9.9462 10.4111 10.2199L12.2654 12L10.4111 13.7801C10.126 14.0538 10.126 14.4962 10.4111 14.7699Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
}), q = {
  "numeric-keyboard": "_numeric-keyboard_bdsa8_1",
  "numeric-keyboard-button-row": "_numeric-keyboard-button-row_bdsa8_10",
  "numeric-keyboard-hidden": "_numeric-keyboard-hidden_bdsa8_38"
}, Gt = l(
  ({
    isActive: a,
    decimalSeparator: t,
    doneText: n,
    clearText: s,
    undoText: r,
    onHandleNumberPointerDown: o,
    onHandleClearPointerDown: i,
    onHandleDecimalSeparatorPointerDown: d,
    onHandleBackspacePointerDown: p,
    onHandleDonePointerDown: v,
    className: g,
    ...E
  }, h) => {
    const C = {
      type: "button",
      /**
       * Ensures buttons are not focusable when "aria-hidden" is "true"
       * @see {@link https://accessibilityinsights.io/info-examples/web/aria-hidden-focus/}
       */
      disabled: !a,
      tabIndex: a ? 0 : -1
    }, _ = {
      ...C,
      onPointerDown: o
    };
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        "aria-hidden": !a,
        className: c(
          q["numeric-keyboard"],
          {
            [q["numeric-keyboard-hidden"]]: !a
          },
          g
        ),
        ref: h,
        ...E
      },
      /* @__PURE__ */ e.createElement("div", { className: q["numeric-keyboard-button-row"] }, /* @__PURE__ */ e.createElement("button", { ..._, value: 1 }, "1"), /* @__PURE__ */ e.createElement("button", { ..._, value: 2 }, "2"), /* @__PURE__ */ e.createElement("button", { ..._, value: 3 }, "3"), /* @__PURE__ */ e.createElement("button", { ..._, value: 4 }, "4"), /* @__PURE__ */ e.createElement("button", { ..._, value: 5 }, "5")),
      /* @__PURE__ */ e.createElement("div", { className: q["numeric-keyboard-button-row"] }, /* @__PURE__ */ e.createElement("button", { ..._, value: 6 }, "6"), /* @__PURE__ */ e.createElement("button", { ..._, value: 7 }, "7"), /* @__PURE__ */ e.createElement("button", { ..._, value: 8 }, "8"), /* @__PURE__ */ e.createElement("button", { ..._, value: 9 }, "9"), /* @__PURE__ */ e.createElement("button", { ..._, value: 0 }, "0")),
      /* @__PURE__ */ e.createElement("div", { className: q["numeric-keyboard-button-row"] }, /* @__PURE__ */ e.createElement(
        "button",
        {
          ...C,
          onPointerDown: i,
          value: s
        },
        s
      ), /* @__PURE__ */ e.createElement(
        "button",
        {
          ...C,
          onPointerDown: d,
          value: t
        },
        t
      ), /* @__PURE__ */ e.createElement(
        "button",
        {
          ...C,
          onPointerDown: p,
          value: r
        },
        /* @__PURE__ */ e.createElement(w, { icon: Bt, label: r, size: "x1" })
      ), /* @__PURE__ */ e.createElement(
        "button",
        {
          ...C,
          onPointerDown: v,
          value: n
        },
        n
      ))
    );
  }
);
Gt.displayName = "NumericKeyboard";
const Ot = "_tag_1x9g6_1", St = "_notification_1x9g6_11", S = {
  tag: Ot,
  notification: St
}, Pt = l(
  ({ variant: a = "notification", className: t, children: n, ...s }, r) => /* @__PURE__ */ e.createElement(
    "strong",
    {
      className: c(S.tag, S[a], t),
      ref: r,
      ...s
    },
    n
  )
);
Pt.displayName = "Tag";
const Ft = l(function(t, n) {
  return /* @__PURE__ */ m.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ m.createElement(
      "path",
      {
        d: "M13 16L9 12L13 8",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      }
    )
  );
}), Vt = l(function(t, n) {
  return /* @__PURE__ */ m.createElement(
    "svg",
    {
      fill: "none",
      ref: n,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ m.createElement(
      "path",
      {
        d: "M11 8L15 12L11 16",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      }
    )
  );
}), Zt = () => I(typeof window > "u").current;
function P({
  activeCard: a,
  cardCount: t,
  containerHasOverflow: n,
  onClick: s,
  position: r
}) {
  return Zt() || !window.matchMedia("(pointer: fine)").matches || !n || r === "prev" && a === 0 || r === "next" && a === t - 1 ? null : /* @__PURE__ */ e.createElement(
    "div",
    {
      className: c({
        [u.leftHandle]: r === "prev",
        [u.rightHandle]: r === "next"
      })
    },
    /* @__PURE__ */ e.createElement(
      "button",
      {
        onClick: () => {
          s?.(r);
        },
        type: "button"
      },
      /* @__PURE__ */ e.createElement(
        w,
        {
          icon: r === "prev" ? Ft : Vt
        }
      )
    )
  );
}
function Kt({
  activeCard: a,
  cardCount: t,
  containerHasOverflow: n
}) {
  return n ? /* @__PURE__ */ e.createElement("div", { className: u.pagination, role: "presentation" }, Array.from({ length: t }, (s, r) => /* @__PURE__ */ e.createElement(
    "span",
    {
      className: c(u.paginationItem, {
        [u.active]: a === r
      }),
      key: `dot-${r}`
    }
  ))) : null;
}
function Xt(a) {
  const [t, n] = z(0);
  return F(() => {
    const s = a.current;
    if (!s)
      return;
    const r = () => {
      const o = s.children.length, i = s.scrollLeft / (s.scrollWidth - s.clientWidth);
      n(Math.round(i * (o - 1)));
    };
    return s.addEventListener("scroll", r), () => {
      s.removeEventListener("scroll", r);
    };
  }, [a.current]), t;
}
const Ut = (a) => {
  const [t, n] = z(!1);
  return F(() => {
    const s = a.current;
    if (!s)
      return;
    n(
      s.scrollWidth > s.clientWidth
    );
    const r = () => {
      n(
        s.scrollWidth > s.clientWidth
      );
    };
    return window.addEventListener("resize", r), () => {
      window.removeEventListener("resize", r);
    };
  }, [a.current]), t;
}, Jt = l(({ children: a, className: t, ...n }, s) => {
  const r = I(null), o = Xt(r), i = Ut(r), d = me.toArray(a).length, v = {
    activeCard: o,
    cardCount: d,
    containerHasOverflow: i,
    onClick: (g) => {
      r.current?.children.item(g === "prev" ? o - 1 : o + 1)?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
    }
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: c(u.horizontalCardGroupWrapper, t),
      ref: s,
      ...n
    },
    /* @__PURE__ */ e.createElement(P, { ...v, position: "prev" }),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: u.horizontalCardGroup,
        "data-card-count": d,
        ref: r
      },
      a
    ),
    /* @__PURE__ */ e.createElement(P, { ...v, position: "next" }),
    /* @__PURE__ */ e.createElement(
      Kt,
      {
        activeCard: o,
        cardCount: d,
        containerHasOverflow: i
      }
    )
  );
});
Jt.displayName = "HorizontalCardGroup";
const Qt = "_timeline_ckebo_1", x = {
  timeline: Qt,
  "timeline-list-item": "_timeline-list-item_ckebo_7",
  "timeline-node-line": "_timeline-node-line_ckebo_11",
  "timeline-node": "_timeline-node_ckebo_11",
  "timeline-node-period": "_timeline-node-period_ckebo_24",
  "timeline-child-container": "_timeline-child-container_ckebo_39"
}, Yt = l(
  ({ className: a, children: t, ...n }, s) => /* @__PURE__ */ e.createElement("ol", { className: c(x.timeline, a), ref: s, ...n }, t)
);
Yt.displayName = "Timeline";
const en = l(
  ({ children: a, ...t }, n) => /* @__PURE__ */ e.createElement("li", { className: x["timeline-list-item"], ref: n, ...t }, /* @__PURE__ */ e.createElement("div", { className: x["timeline-node"] }, /* @__PURE__ */ e.createElement("span", { className: x["timeline-node-period"] }), /* @__PURE__ */ e.createElement("span", { className: x["timeline-node-line"] })), /* @__PURE__ */ e.createElement("div", { className: x["timeline-child-container"] }, a))
);
en.displayName = "TimelineItem";
const tn = "div", nn = l(
  ({
    as: a,
    className: t,
    children: n,
    padded: s = !1,
    ...r
  }, o) => {
    const i = a ?? tn;
    return /* @__PURE__ */ e.createElement(
      i,
      {
        ...r,
        className: c(
          u.card,
          { [u.padded]: s },
          t
        ),
        ref: o
      },
      n
    );
  }
);
nn.displayName = "Card";
const an = l(({ className: a, ...t }, n) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: c(u.cardHeader, a),
    ref: n,
    ...t
  }
));
an.displayName = "CardHeader";
const sn = l(({ children: a, className: t, ...n }, s) => /* @__PURE__ */ e.createElement("h3", { className: c(u.cardTitle, t), ref: s, ...n }, a));
sn.displayName = "CardTitle";
const rn = l(({ className: a, ...t }, n) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: c(u.cardContent, a),
    ref: n,
    ...t
  }
));
rn.displayName = "CardContent";
const on = l(({ className: a, ...t }, n) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: c(u.cardFooter, a),
    ref: n,
    ...t
  }
));
on.displayName = "CardFooter";
const ln = "_tabsList_1nj5r_1", cn = "_tabsTrigger_1nj5r_16", K = {
  tabsList: ln,
  tabsTrigger: cn
}, gn = N.Root, dn = m.forwardRef(({ className: a, ...t }, n) => /* @__PURE__ */ m.createElement(
  N.List,
  {
    className: c(K.tabsList, a),
    ref: n,
    ...t
  }
));
dn.displayName = N.List.displayName;
const mn = m.forwardRef(({ className: a, ...t }, n) => /* @__PURE__ */ m.createElement(
  N.Trigger,
  {
    className: c(K.tabsTrigger, a),
    ref: n,
    ...t
  }
));
mn.displayName = N.Trigger.displayName;
const _n = N.Content;
_n.displayName = N.Content.displayName;
export {
  Z as Accordion,
  V as AccordionHeader,
  ft as Alert,
  Lt as Button,
  nn as Card,
  rn as CardContent,
  tn as CardDefaultElement,
  on as CardFooter,
  lt as CardGroup,
  an as CardHeader,
  sn as CardTitle,
  Wt as Dropdown,
  Jt as HorizontalCardGroup,
  w as Icon,
  At as Link,
  Gt as NumericKeyboard,
  gn as Tabs,
  _n as TabsContent,
  dn as TabsList,
  mn as TabsTrigger,
  Pt as Tag,
  Yt as Timeline,
  en as TimelineItem
};
